import { getAccessToken } from '../app/Auth/Auth';

const callApiFormData = async (method: string, url: string, path: string, formData?: FormData) => {
  try {
    const res = await fetch(url + '/api' + path, {
      method,
      headers: {
        Accept: 'multipart/form-data',
        Authorization: `Bearer ${getAccessToken()}`,
      },
      body: formData,
    });
    return await res.json();
  } catch (error) {
    return { error };
  }
};

export default callApiFormData;
